import { lazy } from 'react';

import Loadable from '../components/Loadable';
import MainLayout from '../layout/MainLayoutAuth';
import RequireSubscription from 'repository/RequireSubscription';

const AccountPage = Loadable(lazy(() => import('../pages/user/Dashboard')));
const StorePage = Loadable(lazy(() => import('../pages/user/Store')));
const UploadPage = Loadable(lazy(() => import('../pages/user/Upload/index')));
const SettingsPage = Loadable(lazy(() => import('../pages/user/Settings')));
const WithdrawalsPage = Loadable(lazy(() => import('../pages/user/Withdrawals')));
const StatementPage = Loadable(lazy(() => import('../pages/user/Statement')));

const UserRoutes = {
    path: '/account/',
    element: <MainLayout />,
    children: [
        {
            path: '',
            element: (
                // <RequireSubscription>
                <AccountPage />
                // </RequireSubscription>
            )
        },
        {
            path: 'store',
            element: (
                // <RequireSubscription>
                <StorePage />
                // </RequireSubscription>
            )
        },
        {
            path: 'upload',
            element: (
                // <RequireSubscription>
                <UploadPage />
                // </RequireSubscription>
            )
        },
        {
            path: 'upload/:id',
            element: (
                // <RequireSubscription>
                <UploadPage />
                // </RequireSubscription>
            )
        },
        {
            path: 'settings',
            element: (
                // <RequireSubscription>
                <SettingsPage />
                // </RequireSubscription>
            )
        },
        {
            path: 'withdrawals',
            element: <WithdrawalsPage />
        },
        {
            path: 'statement',
            element: <StatementPage />
        }
    ]
};


export default UserRoutes;
